import { render, staticRenderFns } from "./AverageChart.vue?vue&type=template&id=a98cdd9c"
import script from "./AverageChart.vue?vue&type=script&lang=js"
export * from "./AverageChart.vue?vue&type=script&lang=js"
import style0 from "./AverageChart.vue?vue&type=style&index=0&id=a98cdd9c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a98cdd9c')) {
      api.createRecord('a98cdd9c', component.options)
    } else {
      api.reload('a98cdd9c', component.options)
    }
    module.hot.accept("./AverageChart.vue?vue&type=template&id=a98cdd9c", function () {
      api.rerender('a98cdd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/average-chart/AverageChart.vue"
export default component.exports